import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { microsoftDelegated, validateAppToken } from '../../../../store/AppTokenAction';
import Loading from '../../../misc/Loading';
import * as AppTokenUtil from '../../../../util/AppTokenUtil';
import { Button, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CoreAppToken, CoreAppTokenValidation } from '../../../../models/CoreAppToken';
import { RequestState } from '../../../../models/RequestState';
import StatusCode from '../../../../util/StatusCode';
import Copy from '../../../misc/Copy';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../store/store';



interface AppTokenMicrosoftApplicationProps {
    appToken: CoreAppToken,
    disableInput: boolean,
    additionalScopes?: string[]
}

const AppTokenMicrosoftApplication = (props: AppTokenMicrosoftApplicationProps) => {

    const appTokenValidationRequestState = useSelector<RootState, RequestState<CoreAppTokenValidation>>(x => x.token.appTokenValidation);
    const dispatch = useDispatch();
    const [isAuthenticating, setIsAuthenticating] = useState(false);

    const { t } = useTranslation('configuration');

    const login = async (appTokenValidate: CoreAppTokenValidation) => {
        let uri = appTokenValidate.flowSyncUXUri ?? '';
        let login = await AppTokenUtil.authWindow(uri);

        if (login.code) {
            setIsAuthenticating(true);
            await generateMicrosoftDelegated(props.appToken.id, login.code)
            setIsAuthenticating(false);
        }

    }

    const generateMicrosoftDelegated = async (appTokenId: string, code: string) => {
        await microsoftDelegated(appTokenId, code)(dispatch);
        await validateAppToken(props.appToken.id, props.additionalScopes);
    }

    if (appTokenValidationRequestState.code === StatusCode.NONE || appTokenValidationRequestState.code === StatusCode.PENDING) {
        return (<Loading />);
    }

    if (appTokenValidationRequestState.code === StatusCode.ERROR) {
        return (
            <div>
                <p>{t('appTokenConfiguration.validationError.failed')}</p>
                <p>{t('appTokenConfiguration.validationError.response', { code: appTokenValidationRequestState.error.code })}</p>
            </div>)
    }

    const appTokenValidation = appTokenValidationRequestState.data;

    if (!appTokenValidation.valid) {
        return (
            <div>
                <p><FontAwesomeIcon icon="triangle-exclamation" className="apptoken-configuration__status-icon--warning" />{t('appTokenConfiguration.configurationRequired')}</p>
                <div>
                    <div>
                        <strong>{t('appTokenConfiguration.microsoftDelegated.step1')}</strong>
                        <div className="push--top">
                            <Label for="copyLinkUri">{t('appTokenConfiguration.microsoftDelegated.shareLink')}: <Copy value={appTokenValidation.copyLinkUri ?? ''} /></Label>
                            <Input name="copyLinkUri" disabled value={appTokenValidation.copyLinkUri} />
                        </div>
                    </div>
                    <div className="push--top">
                        <strong>{t('appTokenConfiguration.microsoftDelegated.step2')}</strong>
                        <div className="apptoken-configuration__button-container">
                            <Button color="primary" disabled={props.disableInput} onClick={() => login(appTokenValidation)}>{t('appTokenConfiguration.microsoftDelegated.login')}</Button>
                            {isAuthenticating && <Loading className="push--left" />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (<div>
        <div className='apptoken-configuration__status'>
            <FontAwesomeIcon icon="check" className="apptoken-configuration__status-icon--ok" />{t('appTokenConfiguration.accessConfigured')}
        </div>
        <div className='apptoken-configuration__status'>
            <FontAwesomeIcon icon="user" className="apptoken-configuration__status-icon" />{t('appTokenConfiguration.microsoftDelegated.serviceAccount')}: {props.appToken.userName}
        </div>
    </div>);
}

export default AppTokenMicrosoftApplication;
